import { checkout, checkoutAddons } from 'src/app/router/paths';
import { SESSION_STORAGE_KEYS } from 'src/app/storage/sessionStorageKeys';

export const getCheckoutPath = ({ isUpsellEssentialsEnabled }: { isUpsellEssentialsEnabled: boolean }) => {
  if (!isUpsellEssentialsEnabled) return checkout.route;

  const hasSeenUpsell = window.sessionStorage.getItem(SESSION_STORAGE_KEYS.seenUpsellEssentials) === 'true';

  return hasSeenUpsell ? checkout.route : checkoutAddons.route;
};
